// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Kxl_","content":"styles_content__dMTcv","tableWrap":"styles_tableWrap__1PVEX"};